module.exports = __webpack_public_path__ + "img/32.439ef321.jpg";